// extracted by mini-css-extract-plugin
export default {"control":"ScalePreview_control__LvfAe","button":"ScalePreview_button__zEyi9","value":"ScalePreview_value__+cLJ+","disabled_icon":"ScalePreview_disabled_icon__opBJg"};